import { Link } from '@tanstack/react-router';
import { type LucideIcon } from 'lucide-react';

import { cn } from '~shared/shadcn/lib/utils';

export interface TabListItem {
  href: string;
  label: string;
  active: boolean;
  icon: LucideIcon;
}

export function TabList({ tabList }: { tabList: Array<TabListItem> }) {
  return (
    <div className='border-b border-border'>
      <div className='flex overflow-x-auto overflow-y-hidden'>
        {tabList.map((tab) => {
          const TabIcon = tab.icon;
          return (
            <Link
              key={tab.href}
              to={tab.href}
              className={cn(
                'flex min-w-0 flex-1 items-center justify-center gap-2 px-3 py-3 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground sm:px-4',
                'mb-[-2px] border-b-2 border-transparent',
                tab.active && 'border-amber-400 bg-amber-50 text-foreground',
              )}
              replace
            >
              <TabIcon className='size-4' />
              <span className='hidden sm:inline'>{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default TabList;
